import apiClient from './apiClient';

/**
 * Creates a new student.
 * @param {object} studentData - The data for the new student (e.g., { email, full_name, phone }).
 * @returns {Promise<object>} The response from the API.
 */
export const createStudent = (studentData) => {
  return apiClient('/students', { body: studentData, method: 'POST' });
};

/**
 * Fetches a list of all students.
 * @returns {Promise<Array>} A promise that resolves to an array of students.
 */
export const getStudents = ({ page = 1, query = '' } = {}) => {
  let url = `/students?page=${page}`;
  if (query) url += `&query=${encodeURIComponent(query)}`;
  return apiClient(url);
};

/**
 * Updates an existing student.
 * @param {string} studentId - The ID of the student to update.
 * @param {object} studentData - The updated data for the student.
 * @returns {Promise<object>} A promise that resolves to the updated student data.
 */
export const updateStudent = (studentId, studentData) => {
  return apiClient(`/students/${studentId}`, { body: studentData, method: 'PUT' });
};

/**
 * Deletes a student.
 * @param {string} studentId - The ID of the student to delete.
 * @returns {Promise<object>} A promise that resolves when the student is deleted.
 */
export const deleteStudent = (studentId) => {
  return apiClient(`/students/${studentId}`, { method: 'DELETE' });
};

/**
 * Fetches resources for a course with assignment status for a student.
 * @param {string|number} studentId
 * @param {string|number} courseId
 * @returns {Promise<Array>} List of resources with assignment status
 */
export const getStudentCourseResources = (studentId, courseId) => {
  return apiClient(`/students/resources/assigned?student_id=${studentId}&course_id=${courseId}`);
};

/**
 * Assigns or unassigns a resource for a student in a course.
 * @param {object} params - { student_id, resource_id, course_id, is_assigned }
 * @returns {Promise<object>} The response from the API.
 */
export const setStudentResourceAssignment = ({ student_id, resource_id, course_id, is_assigned }) => {
  return apiClient('/students/drip-feed', {
    method: 'POST',
    body: { student_id, resource_id, course_id, is_assigned: String(is_assigned) },
  });
}; 